export * from './app-sidebar-nav.component';



// WEBPACK FOOTER //
// ./src/app/components/app-sidebar-nav/index.ts